export const KANBAN_PAGE_SIZE = 10;
export const KANBAN_EMPTY_MESSAGE = "Nenhum item";
export const KANBAN_LOAD_MORE_LABEL = "Mostrar mais";
